import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addApprovalActionApi,
  addRecruitmentTrackerApi,
  createRecruitmentModuleOpenPositionApi,
  deleteRecruitmentModuleOpenPositionApi,
  deleteRecruitmentTrackerApi,
  getApprovalListActionApi,
  getRecruitmentModuleOpenPositionApi,
  getRecruitmentTrackerBulkUploadHistoryData,
  getRecruitmentTrackerListApi,
  getSingleRecruitmentTrackerListApi,
  recruitmentTrackerBulkUploadApi,
  updateHiringCheckListDataApi,
  updateRecruitmentModuleOpenPositionApi,
  updateRecruitmentTrackerListApi,
} from "../../apis/hrmsApis";
import {
  AddApprovalPayloadType,
  AddOpenPositionPayloadType,
  AddRecruitmentTrackerPayloadType,
  ApprovalListPayloadType,
  DeleteOpenPositionPayloadType,
  GetHrmsBulkUploadHistoryPayloadType,
  GetOpenPositionPayloadType,
  GetRecruitmentTrackerPayloadType,
  GetSingleRecruitmentTrackerPayloadType,
  RecruitmentTrackerBulkUploadType,
  UpdateHiringCheckListPayloadType,
  UpdateOpenPositionPayloadType,
} from "../../commonTypes/hrmsTypes";
import {
  AddScheduledUpcomingInterviewsDetailsType,
  SingleScheduledUpcomingInterviewsDetailsType,
} from "../thinksToDo/thinksToDoType";

export const createRecruitmentModuleOpenPositionAction = createAsyncThunk(
  "create/OpenPosition",
  async (data: AddOpenPositionPayloadType) => {
    const response = await createRecruitmentModuleOpenPositionApi(data);
    return response.data;
  }
);

export const updateRecruitmentModuleOpenPositionAction = createAsyncThunk(
  "update/OpenPosition",
  async (data: UpdateOpenPositionPayloadType) => {
    const response = await updateRecruitmentModuleOpenPositionApi(data);
    return response.data;
  }
);

export const getRecruitmentModuleOpenPositionAction = createAsyncThunk(
  "get/OpenPosition",
  async (data: GetOpenPositionPayloadType) => {
    const response = await getRecruitmentModuleOpenPositionApi(data);
    return response.data;
  }
);

export const deleteRecruitmentModuleOpenPositionAction = createAsyncThunk(
  "delete/OpenPosition",
  async (data: DeleteOpenPositionPayloadType) => {
    const response = await deleteRecruitmentModuleOpenPositionApi(data);
    return response.data;
  }
);

export const getRecruitmentTrackerListAction = createAsyncThunk(
  "get/recruiterTracker",
  async (data: GetRecruitmentTrackerPayloadType) => {
    const response = await getRecruitmentTrackerListApi(data);
    return response.data;
  }
);

export const addRecruitmentTrackerAction = createAsyncThunk(
  "add/recruiterTracker",
  async (data: AddRecruitmentTrackerPayloadType) => {
    const response = await addRecruitmentTrackerApi(data);
    return response.data;
  }
);

export const updateRecruitmentTrackerListAction = createAsyncThunk(
  "update/recruiterTracker",
  async (data: AddRecruitmentTrackerPayloadType) => {
    const response = await updateRecruitmentTrackerListApi(data);
    return response.data;
  }
);

export const getSingleRecruitmentTrackerListAction = createAsyncThunk(
  "get/SingleRecruiterTracker",
  async (data: GetSingleRecruitmentTrackerPayloadType) => {
    const response = await getSingleRecruitmentTrackerListApi(data);
    return response.data;
  }
);
export const deleteRecruitmentTrackerAction = createAsyncThunk(
  "delete/recruiterTracker",
  async (data: DeleteOpenPositionPayloadType) => {
    const response = await deleteRecruitmentTrackerApi(data);
    return response.data;
  }
);

export const updateHiringCheckListDataAction = createAsyncThunk(
  "update/hiringCheckList",
  async (data: UpdateHiringCheckListPayloadType) => {
    const response = await updateHiringCheckListDataApi(data);
    return response.data;
  }
);

export const getApprovalListAction = createAsyncThunk(
  "get/approvalList",
  async (data: ApprovalListPayloadType) => {
    const response = await getApprovalListActionApi(data);
    return response.data;
  }
);

export const addApprovalAction = createAsyncThunk(
  "add/approval",
  async (data: AddApprovalPayloadType) => {
    const response = await addApprovalActionApi(data);
    return response.data;
  }
);
export const recruitementTrackerBulkUploadAction = createAsyncThunk(
  `bulkUpload/recruitmentTracker`,
  async (data: RecruitmentTrackerBulkUploadType) => {
    const response = await recruitmentTrackerBulkUploadApi(data);
    return response.data;
  }
);
export const getRecruitmentTrackerBulkUploadHistoryAction = createAsyncThunk(
  `bulkUploadHistory/recruitmentTracker`,
  async (data: GetHrmsBulkUploadHistoryPayloadType) => {
    const response = await getRecruitmentTrackerBulkUploadHistoryData(data);
    return response.data;
  }
);
